import type { PolicyNote } from "../agency/policy.ts";
import type { Requirement } from "../requirements.ts";

/**
 * One carrier: its name, the other names producers use for it, and its portal's start page; for a
 * carrier we quote through a carrier skill, also the lines it quotes and what it needs before its
 * portal is opened (requirements.ts).
 */
export type Carrier = {
  readonly name: string;
  readonly aliases: readonly string[];
  readonly portalUrl: string;
  readonly lines?: string;
  readonly requirements?: readonly Requirement[];
  /** The agency's portal strategies and guidance for this carrier (agency/policy.ts). */
  readonly notes?: readonly PolicyNote[];
};

/** How carriers are told apart: the name trimmed, spaces collapsed, case ignored. */
export function carrierKey(carrier: string): string {
  return carrier.trim().replace(/\s+/g, " ").toLowerCase();
}

/** Whether a name is the carrier's name or one of its aliases, by carrier key. */
export function isCarrier(carrier: Pick<Carrier, "name" | "aliases">, name: string): boolean {
  const key = carrierKey(name);
  return [carrier.name, ...carrier.aliases].some((n) => carrierKey(n) === key);
}
